module.exports = {
  init: {
    game: require("./game.js"),
    social: require("./social.js"),
    editor: require("./editor.js"),
  },
};
